/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React, { Component } from 'react';
import { shape, array, string, object, func } from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import p from 'polyglot/polyglot';

import { createUrl } from 'utils/urlHelper';

import {
  ACCEPT_USER_SUCCESS,
  REJECT_USER_SUCCESS,
  acceptUser as acceptUserAction,
  rejectUser as rejectUserAction,
} from 'actions/admin';

import Button from 'components/Button/Button';

import EditTags from '../EditTags/EditTags';

import styles from './edit-status.scss';

/**
 * This is the EditStatus component.
 *
 * @author Chris Andersson <chris@wbisbi.com>
 */
export class EditStatus extends Component {
  /**
   * Declare expected prop types.
   *
   * @type {object}
   */
  static propTypes = {
    user: object.isRequired,
    auth: shape({
      token: string.isRequired,
    }).isRequired,
    acceptUser: func.isRequired,
    rejectUser: func.isRequired,
    history: object.isRequired,
    roles: array,
  };

  static defaultProps = {
    roles: [],
  };

  onAcceptUser = (data = {}) => {
    const {
      auth: { token },
      user,
      acceptUser,
      history,
    } = this.props;

    const { user_id } = user;
    const { talent_rates, talent_types } = data;

    acceptUser(token, {
      user_id,
      talent_rates,
      talent_types,
    }).then(({ type, payload }) => {
      if (type === ACCEPT_USER_SUCCESS) {
        // Go to profile page.
        history.push(createUrl('profile', payload.slug));
      }
    });
  };

  onRejectUser = () => {
    const {
      auth: { token },
      user: { user_id },
      history,
      rejectUser,
    } = this.props;

    rejectUser(token, { user_id }).then(({ type }) => {
      if (type === REJECT_USER_SUCCESS) {
        history.push(createUrl('home'));
      }
    });
  };

  /**
   * Render EditStatus.
   *
   * @return {Object}
   */
  render() {
    const { user, roles } = this.props;

    const defaultRole =
      user.roles && user.roles.default_role ? user.roles.default_role : null;
    const currentRole = roles.find(r => r.type === defaultRole);

    return (
      <article className={styles.wrapper}>
        <h2 className={styles.title}>
          {p.t('account.admin.edit_status.title')}
        </h2>
        <p className={styles.tagline}>
          {p.t('account.admin.edit_status.tagline')}
        </p>

        <div className={styles.tags}>
          {user.is_client && (
            <Button className={styles.button} onClick={this.onAcceptUser}>
              {p.t('account.admin.edit_status.accept')}
            </Button>
          )}

          {!user.is_client && (
            <EditTags
              user={user}
              compact
              submitButtonText={p.t('account.admin.edit_status.accept')}
              onSubmit={this.onAcceptUser}
              {...currentRole}
            />
          )}
        </div>

        <p className={styles.tagline}>
          {p.t('account.admin.edit_status.reject_title')}
        </p>

        <div className={styles.buttons}>
          <Button className={styles.button} onClick={this.onRejectUser}>
            {p.t('account.admin.edit_status.reject')}
          </Button>
        </div>
      </article>
    );
  }
}

export default withRouter(
  connect(
    ({ auth, user }) => ({ auth, user }),
    {
      acceptUser: acceptUserAction,
      rejectUser: rejectUserAction,
    }
  )(EditStatus)
);
